<template>
  <div class="order-manage-container">
    <!-- 顶部状态选项卡 -->
    <div class="status-tabs">
      <el-tabs v-model="activeStatus" @tab-click="handleTabClick">
        <el-tab-pane name="all">
          <template #label>
            全部 <span class="count-badge">{{ statusCounts.all }}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="pending">
          <template #label>
            待发货 <span class="count-badge">{{ statusCounts.pending }}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="shipped">
          <template #label>
            待收货 <span class="count-badge">{{ statusCounts.shipped }}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="completed">
          <template #label>
            完成 <span class="count-badge">{{ statusCounts.completed }}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="canceled">
          <template #label>
            已取消 <span class="count-badge">{{ statusCounts.canceled }}</span>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 查询区域 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm" label-width="80px">
        <!-- 订单号码 -->
        <el-form-item label="订单号码">
          <el-input
            v-model="searchForm.orderId"
            placeholder="请输入订单ID"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 商品名称 -->
        <el-form-item label="商品名称">
          <el-input
            v-model="searchForm.productName"
            placeholder="请输入商品名称"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 收货地址 -->
        <el-form-item label="收货地址">
          <el-input
            v-model="searchForm.shippingAddress"
            placeholder="请输入收货地址"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 收货人 -->
        <el-form-item label="收货人">
          <el-input
            v-model="searchForm.receiver"
            placeholder="请输入收货人"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 手机号 -->
        <el-form-item label="手机号">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 下单时间范围 -->
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <!-- 快递单号 -->
        <el-form-item label="快递单号">
          <el-input
            v-model="searchForm.expressNumber"
            placeholder="请输入快递单号"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 备注内容 -->
        <el-form-item label="备注内容">
          <el-input
            v-model="searchForm.remarkContent"
            placeholder="请输入备注内容"
            clearable
            class="remark-input"
          >
            <el-select
              slot="prepend"
              v-model="selectedRemarkTag"
              placeholder="选择标签"
              style="width: 120px"
              @change="handleRemarkTagSelect"
            >
              <el-option label="全部备注" value=""></el-option>
              <el-option label="顾客已付款" value="顾客已付款"></el-option>
              <el-option label="顾客未付款" value="顾客未付款"></el-option>
              <el-option label="联系不到顾客" value="联系不到顾客"></el-option>
              <el-option label="找不到地址" value="找不到地址"></el-option>
              <el-option label="沟通不清地址" value="沟通不清地址"></el-option>
              <el-option label="顾客不要了" value="顾客不要了"></el-option>
              <el-option label="没货了" value="没货了"></el-option>
              <el-option label="其他备注" value="##other##"></el-option>
              <el-option label="无备注" value="##none##"></el-option>
            </el-select>
          </el-input>
        </el-form-item>

        <!-- 订单状态 -->
        <el-form-item label="订单状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择订单状态"
            clearable
          >
            <el-option label="全部" value="all"></el-option>
            <el-option label="待发货" value="pending"></el-option>
            <el-option label="待收货" value="shipped"></el-option>
            <el-option label="完成" value="completed"></el-option>
            <el-option label="已取消" value="canceled"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchOrders"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 订单表格 -->
    <div class="order-table">
      <el-table
        :data="orderList"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
      >
        <el-table-column prop="id" label="订单号码" width="130" fixed="left" />
        <el-table-column label="商品数量" width="80">
          <template #default="{ row }"> {{ row.productCount }}件 </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="总计"
          width="80"
          align="right"
        >
          <template #default="{ row }"> ¥{{ row.totalAmount }} </template>
        </el-table-column>
        <!-- 收货地址列 -->
        <el-table-column
          prop="shippingAddress"
          label="收货地址"
          width="240"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <div>{{ formatAddress(row.shippingAddress) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="收货人" width="100">
          <template #default="{ row }">
            {{ formatReceiver(row.receiver) }} {{ row.recipientGender }}
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="100">
          <template #default="{ row }">
            {{ formatPhoneNumber(row.phone) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="下单时间"
          width="160"
          sortable
        />
        <el-table-column label="快递单号" width="130">
          <template #default="{ row }">
            <div v-if="row.expressNumber" class="express-number-container">
              <div class="express-number">{{ row.expressNumber }}</div>
              <div class="express-actions">
                <el-button type="text" @click="openExpressDialog(row)"
                  >填写</el-button
                >
                <el-button
                  type="text"
                  @click="copyExpressNumber(row.expressNumber)"
                  class="copy-btn"
                >
                  <i class="el-icon-document-copy"></i> 复制
                </el-button>
              </div>
            </div>
            <el-button v-else type="text" @click="openExpressDialog(row)"
              >填写</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="备注" width="60">
          <template #default="{ row }">
            <el-button
              type="text"
              :style="{ color: getRemarkColor(row) }"
              @click="openRemarkDialog(row)"
            >
              备注
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="90">
          <template #default="{ row }">
            <el-tag
              :type="getStatusTagType(row.status)"
              size="medium"
              effect="plain"
            >
              {{ row.statusDisplay }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="220" fixed="right">
          <template #default="{ row }">
            <div class="action-buttons">
              <el-button type="text" @click="viewOrderDetail(row)"
                >订单详情</el-button
              >
              <el-button
                v-if="row.status === 'pending' || row.status === 'shipped'"
                type="text"
                @click="cancelOrder(row)"
              >
                取消订单
              </el-button>
              <el-button
                v-if="row.status === 'pending'"
                type="text"
                @click="shipOrder(row)"
              >
                立即发货
              </el-button>
              <el-button
                v-if="row.status === 'shipped'"
                type="text"
                @click="completeOrder(row)"
              >
                完成订单
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <!-- 快递单号弹窗 -->
    <el-dialog
      title="填写快递单号"
      :visible.sync="expressDialogVisible"
      width="500px"
      center
    >
      <div class="express-dialog-content">
        <el-input
          v-model="expressForm.number"
          placeholder="请填写快递单号"
          clearable
          maxlength="40"
          show-word-limit
        ></el-input>
        <div class="dialog-buttons">
          <el-button @click="expressDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitExpressNumber"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 备注弹窗 -->
    <el-dialog
      title="订单备注"
      :visible.sync="remarkDialogVisible"
      width="600px"
      center
    >
      <div class="remark-dialog-content">
        <!-- 正常订单标签 -->
        <div class="tag-group">
          <div class="tag-group-title">正常订单标签</div>
          <el-tag
            class="remark-tag"
            :class="{ 'tag-selected': selectedNormal }"
            @click="toggleNormalTag"
          >
            顾客已付款{{ currentOrder ? currentOrder.totalAmount : "0" }}元
          </el-tag>
        </div>

        <!-- 问题订单标签 -->
        <div class="tag-group">
          <div class="tag-group-title">问题订单标签</div>
          <el-tag
            v-for="(tag, index) in problemTags"
            :key="index"
            class="remark-tag"
            :class="{ 'tag-selected': selectedProblemTags.includes(tag) }"
            @click="toggleProblemTag(tag)"
          >
            {{ tag }}
          </el-tag>
        </div>

        <!-- 备注内容输入 -->
        <div class="remark-input-container">
          <el-input
            type="textarea"
            :rows="4"
            v-model="remarkForm.content"
            placeholder="请输入备注内容"
            maxlength="500"
            show-word-limit
          ></el-input>
        </div>

        <div class="dialog-buttons">
          <el-button @click="remarkDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRemark">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderManage",
  data() {
    return {
      loading: false,
      activeStatus: "pending", // 默认选中待发货
      statusCounts: {
        all: 0,
        pending: 0,
        shipped: 0,
        completed: 0,
        canceled: 0,
      },
      searchForm: {
        orderId: "", // 改为使用订单ID
        productName: "",
        shippingAddress: "",
        receiver: "",
        phone: "",
        timeRange: [],
        expressNumber: "",
        remarkContent: "", // 改为备注内容查询
        status: "pending",
      },
      selectedRemarkTag: "", // 选中的备注标签
      orderList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        totalPages: 1,
      },
      expressDialogVisible: false,
      expressForm: {
        orderId: null,
        number: "",
      },
      remarkDialogVisible: false,
      remarkForm: {
        orderId: null,
        content: "",
      },
      problemTags: [
        "顾客未付款",
        "联系不到顾客",
        "找不到地址",
        "沟通不清地址",
        "顾客不要了",
        "没货了",
      ],
      selectedNormal: false,
      selectedProblemTags: [],
      currentOrder: null,
    };
  },
  mounted() {
    // 读取路由query中的status参数，若存在则更新状态
    const targetStatus = this.$route.query.status;
    if (
      targetStatus &&
      ["pending", "shipped", "completed", "canceled"].includes(targetStatus)
    ) {
      this.activeStatus = targetStatus;
      this.searchForm.status = targetStatus;
    }
    this.fetchOrders();
  },
  methods: {
    // 查询：处理备注标签选择
    handleRemarkTagSelect(value) {
      if (value) {
        this.searchForm.remarkContent = value;
      } else {
        this.searchForm.remarkContent = "";
      }
    },

    // 获取订单列表
    async fetchOrders() {
      try {
        this.loading = true;
        // 获取token
        const token = localStorage.getItem("token") || "";
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          orderId: this.searchForm.orderId, // 改为使用订单ID
          productName: this.searchForm.productName,
          shippingAddress: this.searchForm.shippingAddress,
          receiver: this.searchForm.receiver,
          phone: this.searchForm.phone,
          expressNumber: this.searchForm.expressNumber,
          remarkContent: this.searchForm.remarkContent, // 改为备注内容查询
          status: this.searchForm.status,
        };

        // 处理时间范围
        if (
          this.searchForm.timeRange &&
          this.searchForm.timeRange.length === 2
        ) {
          params.startTime = this.searchForm.timeRange[0];
          params.endTime = this.searchForm.timeRange[1];
        }

        // 过滤空参数
        Object.keys(params).forEach((key) => {
          if (
            params[key] === "" ||
            params[key] === null ||
            params[key] === undefined
          ) {
            delete params[key];
          }
        });
        // 添加认证头，携带 Token
        const response = await this.$http.get("/api/pc/merchant/orders", {
          params,
          headers: {
            Authorization: `Bearer ${token}`, // 键名与现有逻辑一致
          },
        });

        if (response.data.code !== 0) {
          throw new Error(response.data.message || "获取订单数据失败");
        }

        const responseData = response.data.data;

        // 更新订单列表 - 直接使用后端返回的数据，不再重新计算商品数量
        this.orderList = responseData.orders.map((order) => {
          // 处理收货地址
          let shippingAddress = order.shippingAddress;

          // 处理下单时间（转换为本地时间）
          let orderTime = order.orderTime;
          if (orderTime) {
            const date = new Date(orderTime);
            // 转换为本地时间（东八区）
            const localTime = new Date(date.getTime() + 8 * 60 * 60 * 1000);
            orderTime = localTime
              .toISOString()
              .replace("T", " ")
              .substring(0, 19);
          }

          // 返回格式化后的订单数据
          return {
            ...order,
            id: order._id, // 直接使用_id作为订单ID
            shippingAddress,
            recipientGender: order.recipientGender || "",
            orderTime,
            status: order.status,
            statusDisplay: this.formatStatus(order.status),
          };
        });

        // 更新状态计数
        this.statusCounts = {
          all: responseData.counts.all || 0,
          pending: responseData.counts.pending || 0,
          shipped: responseData.counts.shipped || 0,
          completed: responseData.counts.completed || 0,
          canceled: responseData.counts.canceled || 0,
        };

        // 更新分页信息
        this.pagination = {
          currentPage: responseData.pagination.currentPage,
          pageSize: responseData.pagination.pageSize,
          total: responseData.pagination.total,
          totalPages:
            responseData.pagination.totalPages ||
            Math.ceil(
              responseData.pagination.total / responseData.pagination.pageSize
            ),
        };
      } catch (error) {
        // Token 无效/过期处理
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin"); // 跳转商家登录页
        }

        console.error("获取订单失败:", error);

        this.$message({
          message: error.message || "获取订单数据失败，请稍后重试",
          type: "error",
          duration: 3000,
        });

        // 恢复数据为空状态
        this.orderList = [];
        this.statusCounts = {
          all: 0,
          pending: 0,
          shipped: 0,
          completed: 0,
          canceled: 0,
        };
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 切换标签
    handleTabClick(tab) {
      this.activeStatus = tab.name;
      this.searchForm.status = tab.name === "all" ? "all" : tab.name;
      this.pagination.currentPage = 1;
      this.fetchOrders();
    },

    // 查询订单
    searchOrders() {
      this.pagination.currentPage = 1;
      this.fetchOrders();
    },

    // 重置查询条件
    resetSearch() {
      this.searchForm = {
        orderId: "", // 改为使用订单ID
        productName: "",
        shippingAddress: "",
        receiver: "",
        phone: "",
        timeRange: [],
        expressNumber: "",
        remarkContent: "", // 改为备注内容查询
        status: this.activeStatus === "all" ? "all" : this.activeStatus,
      };
      this.selectedRemarkTag = "";
      this.pagination.currentPage = 1;
      this.fetchOrders();
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.fetchOrders();
    },

    // 当前页变化
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchOrders();
    },

    // 打开快递单号弹窗
    openExpressDialog(order) {
      this.currentOrder = order;
      this.expressForm = {
        orderId: order.id,
        number: order.expressNumber || "",
      };
      this.expressDialogVisible = true;
    },

    // 提交快递单号
    async submitExpressNumber() {
      try {
        // 1. 从localStorage获取Token（与现有逻辑保持一致）
        const token = localStorage.getItem("token") || "";

        // 调用API保存快递单号
        await this.$http.put(
          `/api/merchantpc/orders/${this.expressForm.orderId}/express`,
          {
            expressNumber: this.expressForm.number.trim(),
          },
          {
            // 添加Token请求头：格式为 "Bearer + 空格 + Token"
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // 显示成功消息
        this.$message.success("快递单号保存成功");

        // 关闭弹窗
        this.expressDialogVisible = false;

        // 刷新页面数据
        this.fetchOrders();
      } catch (error) {
        console.error("提交快递单号失败:", error);
        // 3. 新增：处理Token无效/过期场景（与现有接口错误逻辑对齐）
        if (error.response?.status === 401) {
          localStorage.removeItem("token"); // 清除无效Token
          this.$router.push("/MerchantLogin"); // 跳转商家登录页
        }
        this.$message.error("提交快递单号失败");
      }
    },

    // 复制快递单号
    copyExpressNumber(number) {
      if (!number) {
        this.$message.warning("没有快递单号可复制");
        return;
      }

      // 使用 Clipboard API 复制文本
      navigator.clipboard
        .writeText(number)
        .then(() => {
          this.$message.success("快递单号已复制到剪贴板");
        })
        .catch((err) => {
          console.error("复制失败:", err);

          // 降级方案：使用 textarea 和 execCommand
          const textArea = document.createElement("textarea");
          textArea.value = number;
          textArea.style.position = "fixed";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
            const successful = document.execCommand("copy");
            if (successful) {
              this.$message.success("快递单号已复制到剪贴板");
            } else {
              this.$message.error("复制失败，请手动复制");
            }
          } catch (err) {
            this.$message.error("复制失败，请手动复制");
          }

          document.body.removeChild(textArea);
        });
    },

    // 打开备注弹窗
    openRemarkDialog(order) {
      this.currentOrder = order;
      this.remarkForm = {
        orderId: order.id,
        content: order.remarkContent || "",
      };

      // 解析现有备注内容初始化标签状态
      this.parseRemarkContent(this.remarkForm.content);
      this.remarkDialogVisible = true;
    },

    // 解析备注内容初始化标签状态
    parseRemarkContent(content) {
      this.selectedNormal = false;
      this.selectedProblemTags = [];

      if (!content) return;

      // 检查正常订单标签
      const normalPattern = /顾客已付款\d+(\.\d{1,2})?元/;
      if (normalPattern.test(content)) {
        this.selectedNormal = true;
        return;
      }

      // 检查问题订单标签
      this.problemTags.forEach((tag) => {
        if (content.includes(tag)) {
          this.selectedProblemTags.push(tag);
        }
      });
    },

    // 切换正常订单标签
    toggleNormalTag() {
      this.selectedNormal = !this.selectedNormal;
      if (this.selectedNormal) {
        this.selectedProblemTags = [];
        this.updateRemarkContent();
      }
    },

    // 切换问题订单标签
    toggleProblemTag(tag) {
      // 1. 查找当前标签在选中数组中的位置
      const index = this.selectedProblemTags.indexOf(tag);
      // 2. 判断标签是否已选中
      if (index > -1) {
        // 若已选中，则从选中数组中移除（取消选中）
        this.selectedProblemTags.splice(index, 1);
      } else {
        // 若未选中，则添加到选中数组（选中该标签）
        this.selectedProblemTags.push(tag);
        this.selectedNormal = false;
      }
      this.updateRemarkContent();
    },

    // 更新备注内容
    updateRemarkContent() {
      let content = "";

      if (this.selectedNormal) {
        content = `顾客已付款${this.currentOrder.totalAmount}元`;
      } else if (this.selectedProblemTags.length > 0) {
        content = this.selectedProblemTags.join("。");
      }

      this.remarkForm.content = content;
    },

    // 提交备注
    async submitRemark() {
      try {
        // 检查正常订单和问题订单标签是否同时存在（互斥）
        if (this.selectedNormal && this.selectedProblemTags.length > 0) {
          this.$message.error("正常订单和问题订单标签不能同时选择");
          return;
        }

        // 获取token
        const token = localStorage.getItem("token") || "";

        await this.$http.put(
          `/api/merchantpc/orders/${this.remarkForm.orderId}/remark`,
          {
            remarkContent: this.remarkForm.content,
          },
          {
            // 添加token请求头
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.$message.success("备注保存成功");
        this.remarkDialogVisible = false;
        this.fetchOrders();
      } catch (error) {
        // 处理token无效/过期的情况
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        }
        console.error("提交备注失败:", error);
        this.$message.error("提交备注失败");
      }
    },

    // 备注二字颜色
    getRemarkColor(order) {
      if (!order.remarkContent) return "#666666"; // 默认灰色

      // 定义匹配规则
      const normalTagPattern = /顾客已付款\d+(\.\d{1,2})?元/; // 支持小数金额
      const problemTags = [
        "顾客未付款",
        "联系不到顾客",
        "找不到地址",
        "沟通不清地址",
        "顾客不要了",
        "没货了",
      ];

      // 提取备注内容
      const notes = order.remarkContent;

      // 检查是否包含正常订单标签
      const hasNormalTag = normalTagPattern.test(notes);

      // 检查是否包含任何问题订单标签
      const hasProblemTag = problemTags.some((tag) => notes.includes(tag));

      // 返回对应颜色
      if (hasNormalTag) return "#009245"; // 绿色
      if (hasProblemTag) return "#ff0c0c"; // 红色
      return "#666666"; // 默认灰色
    },

    // 格式化地址显示（前10个字符+*）
    formatAddress(address) {
      if (!address) return "";
      if (address.length <= 10) return address;
      return address.substring(0, 10) + "*".repeat(address.length - 10);
    },

    // 格式化收货人显示（第一个字符+*）
    formatReceiver(receiver) {
      if (!receiver) return "";
      if (receiver.length <= 1) return receiver;
      return receiver.substring(0, 1) + "*".repeat(receiver.length - 1);
    },

    // 格式化手机号（中间四位替换为****）
    formatPhoneNumber(phone) {
      if (!phone || phone.length !== 11) return phone;
      return phone.substring(0, 3) + "****" + phone.substring(7);
    },

    // 格式化状态显示
    formatStatus(status) {
      const statusMap = {
        pending: "待发货",
        shipped: "待收货",
        completed: "完成",
        canceled: "已取消",
      };
      return statusMap[status] || status;
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      switch (status) {
        case "pending":
          return "warning";
        case "shipped":
          return "";
        case "completed":
          return "success";
        case "canceled":
          return "danger";
        default:
          return "info";
      }
    },

    // 查看订单详情
    viewOrderDetail(order) {
      // 1. 解析目标路由的完整URL（基于路由名称和参数）
      const routeInfo = this.$router.resolve({
        name: "PCOrderDetail", // 保持原路由名称不变
        params: { id: order.id }, // 保持原参数传递不变
      });
      // 2. 新标签页打开目标URL
      window.open(routeInfo.href, "_blank");
    },

    // 取消订单
    cancelOrder(order) {
      this.$confirm("确认取消此订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            // 获取token
            const token = localStorage.getItem("token") || "";

            await this.$http.put(
              `/api/merchantpc/orders/${order.id}/cancel`,
              {}, // 空请求体（保持参数位置正确）
              {
                // 添加token请求头
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            this.$message.success("订单已取消");
            this.fetchOrders(); // 刷新订单列表
          } catch (error) {
            // 处理token无效/过期的情况
            if (error.response?.status === 401) {
              localStorage.removeItem("token");
              this.$router.push("/MerchantLogin");
              return;
            }

            console.error("取消订单失败:", error);
            this.$message.error("取消订单失败");
          }
        })
        .catch(() => {});
    },

    // 立即发货
    async shipOrder(order) {
      try {
        await this.$confirm("确认要立即发货吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        // 获取token
        const token = localStorage.getItem("token") || "";

        const response = await this.$http.put(
          `/api/merchantpc/orders/${order.id}/ship`,
          {}, // 空请求体（如果后端不需要请求参数）
          {
            // 添加token请求头
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 0) {
          this.$message.success("发货成功");

          // 发货成功后切换到待收货标签页
          this.activeStatus = "shipped";
          this.searchForm.status = "shipped";

          this.fetchOrders(); // 刷新订单列表
        } else {
          this.$message.error(response.data.message || "发货失败");
        }
      } catch (error) {
        // 新增：处理token无效/过期的情况
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
          return;
        }

        if (error.response && error.response.status === 400) {
          // 处理 400 错误
          console.error("发货失败 - 请求格式错误:", error);
          this.$message.error("请求格式错误，请检查参数");
        } else if (error !== "cancel") {
          console.error("发货失败:", error);
          this.$message.error("发货失败，请重试");
        }
        // 如果是用户取消，不需要任何处理
      }
    },

    // 完成订单方法
    async completeOrder(order) {
      this.$confirm("确认要完成此订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            // 获取token
            const token = localStorage.getItem("token") || "";

            const response = await this.$http.put(
              `/api/merchantpc/orders/${order.id}/complete`,
              {}, // 空请求体（根据接口需求调整）
              {
                // 添加token请求头
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response.data.code === 0) {
              this.$message.success("订单已完成");
              this.fetchOrders(); // 刷新订单列表
            } else {
              this.$message.error(response.data.message || "完成订单失败");
            }
          } catch (error) {
            // 处理token无效/过期的情况
            if (error.response?.status === 401) {
              localStorage.removeItem("token");
              this.$router.push("/MerchantLogin");
              return;
            }

            console.error("完成订单失败:", error);
            this.$message.error("完成订单失败，请重试");
          }
        })
        .catch(() => {
          // 用户取消操作
        });
    },
  },
};
</script>

<style scoped>
.order-manage-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.status-tabs {
  margin-bottom: 20px;
}

.count-badge {
  display: inline-block;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: #f0f2f5;
  border-radius: 10px;
  padding: 0 6px;
  font-size: 12px;
  margin-left: 4px;
}

.search-area {
  margin-bottom: 20px;
  background: #f8f8f8;
  padding: 15px;
  border-radius: 4px;
}

.order-table {
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
}

/* 备注弹窗样式 */
.remark-dialog-content {
  padding: 10px;
}

.tag-group {
  margin-bottom: 20px;
}

.tag-group-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.remark-tag {
  margin-right: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.remark-tag:hover {
  opacity: 0.8;
}

.tag-selected {
  background-color: #409eff;
  color: white;
}

.remark-input-container {
  margin-bottom: 20px;
}

.dialog-buttons {
  text-align: right;
}

/* 快递单号样式 */
.express-number-container {
  display: flex;
  flex-direction: column;
}

.express-number {
  font-weight: bold;
  margin-bottom: 5px;
}

.express-actions {
  display: flex;
  justify-content: space-between;
}

.copy-btn {
  color: #409eff;
}

.copy-btn:hover {
  color: #66b1ff;
}

/* 快递单号弹窗样式 */
.express-dialog-content {
  padding: 20px;
}

.dialog-buttons {
  margin-top: 20px;
  text-align: right;
}

/* 备注输入框样式 */
.remark-input ::v-deep .el-input-group__prepend {
  background-color: #fff;
}
</style>